export const PrmPermissions = {
  VIEW_PEOPLE: 'VIEW_PEOPLE',
  VIEW_PEOPLE_SENSITIVE_DETAILS: 'VIEW_PEOPLE_SENSITIVE_DETAILS',
  EDIT_PEOPLE: 'EDIT_PEOPLE',
  EDIT_ROLES: 'EDIT_ROLES',
  IMPERSONATE: 'IMPERSONATE',
  ADMIN_ACCESS: 'ADMIN_ACCESS'
};



// WEBPACK FOOTER //
// ./src/gs-core/common/models/prm-permissions.ts